import { render, staticRenderFns } from "./menu-sync-setting-form.vue?vue&type=template&id=60711bec"
import script from "./menu-sync-setting-form.vue?vue&type=script&lang=js"
export * from "./menu-sync-setting-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports